import { useEffect, useState } from 'react'

import produce from 'immer'
import { last, remove } from 'lodash'

import window from 'common/window'

const MAX_TRACKED_HISTORY_LENGTH = 10

export const updateArr = (historyUrls, path) => {
  return produce(historyUrls, (draft) => {
    draft.push(path)
    if (draft.length > MAX_TRACKED_HISTORY_LENGTH) {
      const firstIdx = draft.length - MAX_TRACKED_HISTORY_LENGTH
      remove(draft, (url, idx) => {
        return idx < firstIdx
      })
    }
  })
}

const useHistoryUrls = (history) => {
  const referrerToThisApp = window.document.referrer.replace(window.location.origin, '')
  const [historyUrls, setHistoryUrls] = useState([referrerToThisApp])

  useEffect(() => {
    return history.listen(() => {
      const entry = window.location.pathname
      if (last(historyUrls) !== entry) {
        setHistoryUrls(updateArr(historyUrls, entry))
      }
    })
  }, [history, historyUrls])

  return historyUrls
}

export default useHistoryUrls
